import { render, staticRenderFns } from "./summaryOpinions.vue?vue&type=template&id=00e3bad7&scoped=true"
import script from "./summaryOpinions.vue?vue&type=script&lang=js"
export * from "./summaryOpinions.vue?vue&type=script&lang=js"
import style0 from "./summaryOpinions.vue?vue&type=style&index=0&id=00e3bad7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e3bad7",
  null
  
)

export default component.exports